/**
 * @module ol/style
 */
export { default as Circle } from './style/Circle.js';
export { default as Fill } from './style/Fill.js';
export { default as Icon } from './style/Icon.js';
export { default as IconImage } from './style/IconImage.js';
export { default as Image } from './style/Image.js';
export { default as RegularShape } from './style/RegularShape.js';
export { default as Stroke } from './style/Stroke.js';
export { default as Style } from './style/Style.js';
export { default as Text } from './style/Text.js';
//# sourceMappingURL=style.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/style.js
// module id = 762
// module chunks = 8